import { FieldProps } from 'components/Wizards/Wizard/Form/Types'

import { useField, useFormikContext } from 'formik'
import { Input } from 'almanac-ui/TextInputField/Input'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { useIsUrlCrawlable } from 'hooks/useIsUrlCrawlable'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

export const Website = ({ name, schema }: FieldProps) => {
  const {
    meta: { placeholder, rows },
  } = schema.describe()

  const { status } = useFormikContext()
  const [field, meta] = useField(name)
  const { touched, error } = meta
  const { isValid, errorMessage } = useIsUrlCrawlable(field.value)

  if (status === FormStatus.AutoFilling) return <TextFieldLoadingState />

  return (
    <Input
      placeholder={placeholder}
      rows={rows}
      isValid={touched ? !error && isValid : true}
      size="lg"
      name={field.name}
      value={field.value.toLowerCase()}
      onChange={field.onChange}
      aria-label={field.name}
      validMessage={field.value.length > 0 && isValid ? 'Looks like a valid URL!' : undefined}
      errorMessage={errorMessage}
    />
  )
}
